import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMoneyCircle32Filled(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconMoneyCircle32Filled"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M16 28c6.627 0 12-5.373 12-12S22.627 4 16 4 4 9.373 4 16s5.373 12 12 12m1-19.25a1 1 0 1 0-2 0v.73c-.798.126-1.486.396-2.025.86-.817.701-1.106 1.683-1.106 2.694 0 1.24.653 2.08 1.454 2.643.742.522 1.693.867 2.483 1.153l.018.007c.863.313 1.555.565 2.05.897.443.297.586.56.586.903 0 .678-.268 1.135-.654 1.443-.412.33-1.004.523-1.641.523a3.8 3.8 0 0 1-2.123-.656 4 4 0 0 1-.698-.59l-.026-.03-.002-.002a1 1 0 0 0-1.557 1.255l.78-.625-.78.625.002.003.003.003.007.009.02.024.066.076q.082.092.23.236A6.04 6.04 0 0 0 15 22.484v.766a1 1 0 0 0 2 0v-.716a4.46 4.46 0 0 0 2.055-.892c.85-.68 1.405-1.706 1.405-3.005 0-1.224-.68-2.033-1.472-2.564-.707-.475-1.61-.8-2.372-1.077l-.11-.04c-.855-.31-1.543-.57-2.031-.915-.435-.306-.606-.598-.606-1.007 0-.637.172-.974.41-1.178.269-.231.812-.459 1.886-.459.946 0 1.563.31 1.937.591a2.4 2.4 0 0 1 .491.492q.01.011.01.015a1 1 0 0 0 1.721-1.02l-.864.504.864-.505-.002-.003-.003-.004-.007-.011a1 1 0 0 0-.073-.113 4 4 0 0 0-.192-.251 4.4 4.4 0 0 0-.745-.704A5 5 0 0 0 17 9.455z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMoneyCircle32Filled);
